export const dataLibI = [{
  word: 'i',
  partOfSpeech: 'PRO',
  definition: ['Third person singular pronoun'],
  egSentenceKw: 'Lè i wivé, i wè nou.',
  egSentenceEn: 'When he arrived, he saw us.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. il]',
  dialect: '🇱🇨',
  variant: ['li'],
}, {
  word: 'ilèkté',
  partOfSpeech: 'V',
  definition: ['to elect'],
  egSentenceKw: 'Yo vlé ilèkté\'y pou wépwézanté nou an lòt ilèksyon-an.',
  egSentenceEn: 'They want to elect him to represent us in the next election.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. elect]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'inyowans',
  partOfSpeech: 'N',
  definition: ['ignorance'],
  egSentenceKw: 'Kité yo wété adan inyowans yo.',
  egSentenceEn: 'Let them remain in their ignorance.',
  synonym: ['boutèy nwè'],
  antonym: ['lakopwan', 'nnòlaj'],
  etymology: '[< Fr. ignorance]',
  dialect: '🇱🇨',
  variant: [null],
},
];
